import { Color, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

interface HeaderWrapperProps {
  withMargin?: boolean
}

export const HeaderWrapper = styled.header<HeaderWrapperProps>`
  display: flex;
  align-items: center;
  flex-shrink: 0;
  justify-content: space-between;
  width: 100%;
  margin-bottom: ${({ withMargin }) => (withMargin ? Spacing.S32 : 'initial')};
  padding: ${Spacing.S24} ${Spacing.S40};
  background-color: ${Color.White};
`

export const SideHeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;
  gap: ${Spacing.S6};
  margin-left: auto;
`
